var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 2.75C3.96239 2.75 3.54271 2.92384 3.23327 3.23327C2.92384 3.54271 2.75 3.96239 2.75 4.4V15.2C2.75 15.6376 2.92384 16.0573 3.23327 16.3667C3.54271 16.6762 3.96239 16.85 4.4 16.85H5.6C6.01421 16.85 6.35 17.1858 6.35 17.6C6.35 18.0142 6.01421 18.35 5.6 18.35H4.4C3.56457 18.35 2.76335 18.0181 2.17261 17.4274C1.58187 16.8366 1.25 16.0354 1.25 15.2V4.4C1.25 3.56457 1.58187 2.76335 2.17261 2.17261C2.76335 1.58187 3.56457 1.25 4.4 1.25H15.2C16.0354 1.25 16.8366 1.58187 17.4274 2.17261C18.0181 2.76335 18.35 3.56457 18.35 4.4V5.6C18.35 6.01421 18.0142 6.35 17.6 6.35C17.1858 6.35 16.85 6.01421 16.85 5.6V4.4C16.85 3.96239 16.6762 3.54271 16.3667 3.23327C16.0573 2.92384 15.6376 2.75 15.2 2.75H4.4ZM12.8 11.15C11.8887 11.15 11.15 11.8887 11.15 12.8V23.6C11.15 24.5113 11.8887 25.25 12.8 25.25H23.6C24.5113 25.25 25.25 24.5113 25.25 23.6V12.8C25.25 11.8887 24.5113 11.15 23.6 11.15H12.8ZM9.65 12.8C9.65 11.0603 11.0603 9.65 12.8 9.65H23.6C25.3397 9.65 26.75 11.0603 26.75 12.8V23.6C26.75 25.3397 25.3397 26.75 23.6 26.75H12.8C11.0603 26.75 9.65 25.3397 9.65 23.6V12.8Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.ce7bb29b.svg";
export { ForwardRef as ReactComponent };